import { BasePostRequest } from './core/basePostRequest';
import { ApiResponse, Success } from 'acscp/api/responses';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';

export class PasswordResetRequest extends BasePostRequest<undefined> {
    constructor(public username: string, public resetToken: string, public password: string) {
        super('users/password-reset', {}, {username, resetToken, password}, t.undefined, Authentication.None);
    }
}
